import { createFileRoute, NavigateOptions } from '@tanstack/react-router';

import { z } from 'zod';
import { useAuth } from '~/components/Providers/AuthProvider';
import { useEffect } from 'react';
import { toastKeys } from '~/util/types/toasts';
import { seo } from '~/util';

const logoutSchema = z.object({
    redirectTo: z.string().optional().default('/').catch('/'),
    showToast: z
        .enum(toastKeys)
        .optional()
        .default('logoutSuccess')
        .catch('logoutSuccess'),
});

export const Route = createFileRoute('/logout')({
    validateSearch: logoutSchema,
    head: () => ({
        meta: seo({
            title: 'Logout',
            description: 'Logout from your AREDL account',
        }),
    }),
    component: LogoutComponent,
});

function LogoutComponent() {
    const { logout } = useAuth() ?? {};
    const { redirectTo, showToast } = Route.useSearch({
        select: ({ redirectTo, showToast }) => ({ redirectTo, showToast }),
    });

    useEffect(() => {
        logout?.(showToast, (redirectTo || '/') as NavigateOptions['to']);
    }, [logout, redirectTo, showToast]);
}
